import { useState, useEffect } from 'react';
import Preloader from './components/Preloader/Preloader';
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import Overview from './components/Overview/Overview';
import Collage from './components/Collage/Collage';
import Timeline from './components/Timeline/Timeline';
import Quote from './components/Quote/Quote';
import MusicPlayer from './components/MusicPlayer/MusicPlayer';
import Footer from './components/Footer/Footer';

const App = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Preloader isLoading={isLoading} />
      {!isLoading && (
        <>
          <Navbar />
          <main>
            <Hero />
            <Overview />
            <Collage />
            <Timeline />
            <Quote />
          </main>
          <Footer />
          <MusicPlayer />
        </>
      )}
    </>
  );
};

export default App;
